import { H2RInput } from "../../imports";
import { ReplaceWithDataSource } from "../helpers/variable";

export const GraphicEditor = ({ cue, onUpdate }) => {
	return (
		<>
			<H2RInput
				label="URL"
				value={cue.url}
				placeholder="https://h2r.graphics/"
				onChange={(value) => {
					onUpdate({
						url: value,
					});
				}}
			/>
			<H2RInput
				label="Message (Small text)"
				value={cue.message}
				placeholder="Scan me"
				onChange={(value) => {
					onUpdate({
						message: value,
					});
				}}
			/>
			<H2RInput
				label={`QR colour`}
				value={cue.fgColour || "#000000"}
				colourPicker={true}
				onChange={(value) => {
					onUpdate({ fgColour: value });
				}}
			/>
			<H2RInput
				label={`Background colour`}
				value={cue.bgColour || "#FFFFFF"}
				colourPicker={true}
				onChange={(value) => {
					onUpdate({ bgColour: value });
				}}
			/>
		</>
	);
};

export const GraphicCueContent = ({ cue }) => {
	return (
		<div
			className={`overflow-ellipsis w-48 md:w-auto max-w-xs md:max-w-sm lg:max-w-lg overflow-hidden
        
        `}
		>
			<span className="font-semibold">
				<ReplaceWithDataSource text={cue.url} keepBrakets={true} styled={true} />
			</span>
		</div>
	);
};
